import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .list-item {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: row;
    gap: 8px;
    text-align: left;
  }

  .bullet-container {
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const Bullet = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 4px;
  background-color: white;
`;

export const BulletedList = ({
  children,
  key,
}: React.PropsWithChildren<{ key: string }>) => {
  return (
    <Container>
      {React.Children.map(children, (child, index) => {
        return (
          <div key={`${key}-${index}`} className="list-item">
            <div className="bullet-container">
              <Bullet />
            </div>

            {child}
          </div>
        );
      })}
    </Container>
  );
};
